<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="AccountDetails" toName="收款账户设置" goPathName="账户概览"></Breadcrumb>
      <a-form :form="form" @submit="handleSubmit" style="padding-top:30px">
        <a-form-item label="账户名" v-bind="formItemLayout">
          <a-input placeholder="请输入"
                   v-decorator="['accountName', { rules: [{ required: true, message: '请输入账户名' }] }]"
          />
        </a-form-item>
        <a-form-item label="开户银行所在省市" v-bind="formItemLayout">
          <!--<a-cascader style="max-width:400px;" :options="provinceList" @change="onCityChange" placeholder="请选择所在省市城市" /> :fieldNames="{label: 'value', value: 'key', children: 'param'}"-->
          <a-cascader
            style="max-width: 400px;"
            :options="provinceList"
            @change="onCityChange"
            :value='defaultValue'
            placeholder="请选择所在省市城市"
          />
        </a-form-item>
        <a-form-item label="开户银行" v-bind="formItemLayout">
          <a-input placeholder="输入银行名精确到支行"
                   v-decorator="['bankName', { rules: [{ required: true, message: '请输入开户银行' }] }]"
          />
        </a-form-item>
        <a-form-item label="银行账号" v-bind="formItemLayout">
          <a-input placeholder="请输入"
                   v-decorator="['cardNo', { rules: [{ required: true, message: '请输入银行账号' }] }]"
          />
        </a-form-item>

        <a-form-item label="注册手机号码" v-bind="formItemLayout">
          <a-input
            v-model="mobile"
            :disabled="true"
            placeholder="请输入手机号"
          ></a-input>
        </a-form-item>

        <a-form-item label="图形验证码" v-bind="formItemLayout">
          <a-input
            style="max-width: 290px"
            v-decorator="['verificationImg', {rules:[{required: true, message:'输入图形验证码'}]}]"
            placeholder="请输入">
          </a-input>
          <img style="margin-left:10px;width:130px;height:31px" :src="imageCodeUrl" alt="验证码" class="img-code"
               @click="restImageCodeUrl()">
        </a-form-item>

        <a-form-item label="安全验证码" v-bind="formItemLayout">
          <a-input placeholder="请输入" style="max-width:290px"
                   v-decorator="['smsCode', { rules: [{ required: true, message: '请输入安全验证码' }] }]"
          />
          <a-button v-if="second<=0" style="margin-left:10px;" @click="getSmsCode()">获取验证码</a-button>
          <a-button v-else style="margin-left: 10px">{{ second }}秒后重新发送</a-button>
        </a-form-item>
        <a-form-item v-bind="formItemLayoutBtn">
          <a-button type="primary" html-type="submit">保存信息</a-button>
          <a-button @click="backEvent" style="margin-left: 10px">返回</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import formMixins from '../../../utils/mixins/formMixins'
import countDownHelper from '../../../utils/helper/countDownHelper'

export default {
  name: 'AddInletContent',
  mixins: [formMixins],
  components: {
    Breadcrumb
  },
  data() {
    return {
      visible: false,
      type: 1,
      visiblePopup: false,
      id: this.$route.query.id,
      merchantBankInfo: {},
      provinceList: [],
      headers: {
        authorization: 'authorization-text'
      },
      mobile: '',
      second: 0,
      imageCodeUrl: '',
      defaultValue: [],
      randomNum: ''
    }
  },
  mounted() {
    this.getProvinceList()
    this.getInfo()
    this.mobile = this.$store.getters.userInfo.mobile
    this.restImageCodeUrl()
    this.bindVisible = true
    this.updateForm({
      verificationImg: ''
    })
  },
  methods: {
    getProvinceList() {
      this.getHttpServices().getBaseService().get('province/getProvinceCityCounty').then(res => {
        this.provinceList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getInfo() {
      this.getHttpServices().getUserService().get('/api/v2/merchant/acc/set/detail').then(res => {
        if (!res) {
          this.merchantBankInfo = {}
        } else {
          this.merchantBankInfo = res
        }
        this.getSetInfo(res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getSetInfo(res) {
      if (res) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            accountName: res.accountName,
            bankName: res.bankName,
            cardNo: res.cardNo
            // cityId: res.cityId,
            // id: res.id,
            // merchantId: res.merchantId,
            // provinceId: res.provinceId,
            // areaId:res.areaId,
            // defaultValue:[res.provinceId,res.cityId,res.areaId]
          })
        })
        this.merchantBankInfo.id = res.id
        this.merchantBankInfo.merchantId = res.merchantId
        this.merchantBankInfo.provinceId = res.provinceId
        this.merchantBankInfo.cityId = res.cityId
        this.merchantBankInfo.areaId = res.areaId
        this.defaultValue = [res.provinceId, res.cityId, res.areaId]
      }

    },
    restImageCodeUrl() {
      this.randomNum = (Math.random() * new Date().getTime()).toFixed(0)
      this.imageCodeUrl = this.getAppConfig().baseUrl + 'code/getCode/' + this.randomNum
    },
    getSmsCode() {
      const verificationImg = this.form.getFieldProps('verificationImg').props.value
      this.getLogUtils().logWithTag('verificationImg==', verificationImg)
      if (verificationImg && (typeof verificationImg === 'string' || typeof verificationImg === 'number')) {
        const params = {
          effect: 5,
          mobile: this.mobile,
          randomNum: this.randomNum,
          userType: 1,
          verificationImg: verificationImg
        }
        this.getHttpServices().getBaseService().post('sms/verification', params)
          .then(res => {
            this.$message.success('短信验证码已经发送')
            this.startTimer()
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.$message.success('请输入图形验证码')
      }

    },
    startTimer() {
      if (!this.timer) {
        this.timer = new countDownHelper(60000, 1000)
        this.timer.onCountDownListener = (timeInfo) => {
          this.second = timeInfo.second
        }
        this.timer.onFinishListener = () => {
          this.second = 0
          this.timer = undefined
        }
        this.timer.start()
      }
    },
    onCityChange(value) {
      if (value && value.length) {
        this.merchantBankInfo.provinceId = value[0]
        this.merchantBankInfo.cityId = value[1]
        this.merchantBankInfo.areaId = value[2]
        this.defaultValue = [value[0], value[1], value[2]]
      }
    },
    showModel() {
      this.visiblePopup = true
    },
    handleSubmit(e) {
      e.preventDefault()
      if (!this.merchantBankInfo.provinceId) {
        return this.$message.warn('请选择开户银行所在省市区！')
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.getLogUtils().logWithTag(this.merchantBankInfo)
          this.getHttpServices().getUserService().post('/api/v2/merchant/acc/set/submit', {
            accountName: values.accountName,
            bankName: values.bankName,
            cardNo: values.cardNo,
            cityId: this.merchantBankInfo.cityId,
            id: this.merchantBankInfo.id,
            provinceId: this.merchantBankInfo.provinceId,
            areaId: this.merchantBankInfo.areaId,
            smsCode: values.smsCode
          })
            .then(res => {
              this.$message.success('保存成功')
              setTimeout(() => {
                this.$router.push({
                  name: 'AccountDetails'
                })
              }, 2000)
            }).catch(reason => this.showNetWorkErrorMessage(reason))

        }
      })

    }

  }
}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.pl10 {
  padding-left: 10px;
}
</style>